// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/style/login.css */

/* Импортируем шрифт для футуристичного/минималистичного вида */
/* Google Fonts: Inter - чистый, современный sans-serif */

/* Глобальные сбросы и базовые стили */
*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif; /* Использование импортированного шрифта */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
 
.login-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Занимает всю высоту viewport */
  background-color: #0a0a1a; /* Очень темный, почти черный фон с фиолетовым оттенком */
  color: #e0e0e0; /* Светлый текст для контраста */
}

.login-header {
  background-color: #1a0f2b; /* Темный пурпурный цвет для шапки */
  color: #f0f0f0;
  padding: 25px 0;
  text-align: center;
  box-shadow: 0 0 15px rgba(147, 112, 219, 0.4); /* Мягкое фиолетовое свечение */
  border-bottom: 1px solid rgba(147, 112, 219, 0.2); /* Тонкая разделительная линия */
}

.login-header h1 {
  margin: 0;
  font-size: 2.8em;
  font-weight: 700;
  letter-spacing: 2px; /* Небольшой межбуквенный интервал */
  text-shadow: 0 0 10px rgba(147, 112, 219, 0.7); /* Эффект свечения для текста */
}

.login-main-content {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login-form-container {
  background-color: rgba(20, 0, 40, 0.8); /* Полупрозрачный темно-пурпурный фон для эффекта "стекла" */
  padding: 45px;
  border-radius: 12px; /* Более мягкие углы */
  box-shadow: 0 0 40px rgba(138, 43, 226, 0.4), /* Внешнее фиолетовое свечение */
              inset 0 0 15px rgba(147, 112, 219, 0.2); /* Внутреннее свечение */
  border: 1px solid rgba(147, 112, 219, 0.3); /* Тонкая фиолетовая рамка */
  width: 100%;
  max-width: 420px; /* Немного шире для лучшего вида */
  text-align: center;
  backdrop-filter: blur(5px); /* Эффект размытия фона (для современного "стеклянного" вида) */
  -webkit-backdrop-filter: blur(5px); /* Для Safari */
}

.login-form-container h2 {
  margin-top: 0;
  margin-bottom: 35px;
  color: #9370DB; /* Средний пурпурный для заголовка */
  font-size: 2.2em;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(147, 112, 219, 0.6);
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 25px; /* Больше отступов между элементами формы */
}

.form-group {
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 400;
  color: #c0c0c0; /* Светло-серый для меток */
  font-size: 0.95em;
  letter-spacing: 0.5px;
}

.form-group input[type="text"],
.form-group input[type="password"] {
  width: 100%;
  padding: 14px 18px;
  background-color: rgba(10, 0, 20, 0.6); /* Очень темный, полупрозрачный фон для полей */
  border: 1px solid rgba(147, 112, 219, 0.4); /* Фиолетовая рамка */
  border-radius: 8px; /* Слегка закругленные углы */
  font-size: 1.05em;
  color: #f0f0f0; /* Светлый текст внутри полей */
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-group input[type="text"]::placeholder,
.form-group input[type="password"]::placeholder {
  color: #888; /* Цвет плейсхолдера */
}

.form-group input[type="text"]:focus,
.form-group input[type="password"]:focus {
  border-color: #8A2BE2; /* Яркий фиолетовый при фокусе */
  outline: none;
  box-shadow: 0 0 15px rgba(138, 43, 226, 0.7), /* Яркое фиолетовое свечение при фокусе */
              inset 0 0 8px rgba(138, 43, 226, 0.3);
  background-color: rgba(10, 0, 20, 0.8); /* Чуть темнее при фокусе */
}

.login-button {
  background: linear-gradient(45deg, #8A2BE2, #9370DB); /* Градиент от яркого фиолетового до пурпурного */
  color: white;
  padding: 16px 30px;
  border: none;
  border-radius: 8px;
  font-size: 1.2em;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 25px;
  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4); /* Мягкая тень для "парящего" эффекта */
  letter-spacing: 1px;
}

.login-button:hover {
  background: linear-gradient(45deg, #9370DB, #8A2BE2); /* Изменение направления градиента при наведении */
  transform: translateY(-3px); /* Небольшой эффект поднятия */
  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6); /* Более выраженная тень */
}

.login-button:active {
  transform: translateY(0);
  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.4);
  background: #8A2BE2; /* Сплошной цвет при нажатии */
}

/* Стили для футера (если он не имеет своего отдельного CSS-файла и вы хотите его стилизовать здесь) */
/* Если Footer имеет свой Footer.css, то эти стили могут быть переопределены или дополнены там */
footer.footer { /* Указываем класс, чтобы не конфликтовать с тегом <footer/> */
  background-color: #120720; /* Очень темный пурпурный */
  color: #b0b0b0;
  text-align: center;
  padding: 20px 0;
  font-size: 0.85em;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(147, 112, 219, 0.2); /* Мягкое свечение снизу */
  border-top: 1px solid rgba(147, 112, 219, 0.1);
}

/* Адаптивность для маленьких экранов */
@media (max-width: 600px) {
  .login-form-container {
    padding: 35px 25px;
    margin: 0 15px;
  }

  .login-header h1 {
    font-size: 2.2em;
  }

  .login-form-container h2 {
    font-size: 1.9em;
  }

  .login-button {
    padding: 14px 25px;
    font-size: 1.1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/style/login.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,+DAA+D;AAC/D,yDAAyD;;AAGzD,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC,EAAE,0CAA0C;EAC5E,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,iCAAiC;EACpD,yBAAyB,EAAE,yDAAyD;EACpF,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6CAA6C,EAAE,+BAA+B;EAC9E,iDAAiD,EAAE,gCAAgC;AACrF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE,oCAAoC;EACzD,8CAA8C,EAAE,+BAA+B;AACjF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sCAAsC,EAAE,4DAA4D;EACpG,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C;qDACmD,EAAE,wBAAwB;EAC7E,0CAA0C,EAAE,4BAA4B;EACxE,WAAW;EACX,gBAAgB,EAAE,kCAAkC;EACpD,kBAAkB;EAClB,0BAA0B,EAAE,+DAA+D;EAC3F,kCAAkC,EAAE,eAAe;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,oCAAoC;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,2CAA2C;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,2BAA2B;EAC3C,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sCAAsC,EAAE,+CAA+C;EACvF,0CAA0C,EAAE,qBAAqB;EACjE,kBAAkB,EAAE,6BAA6B;EACjD,iBAAiB;EACjB,cAAc,EAAE,+BAA+B;EAC/C,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;;EAEE,WAAW,EAAE,sBAAsB;AACrC;;AAEA;;EAEE,qBAAqB,EAAE,gCAAgC;EACvD,aAAa;EACb;mDACiD;EACjD,sCAAsC,EAAE,2BAA2B;AACrE;;AAEA;EACE,oDAAoD,EAAE,iDAAiD;EACvG,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C,EAAE,uCAAuC;EACvF,mBAAmB;AACrB;;AAEA;EACE,oDAAoD,EAAE,kDAAkD;EACxG,2BAA2B,EAAE,8BAA8B;EAC3D,+CAA+C,EAAE,0BAA0B;AAC7E;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA,sGAAsG;AACtG,gGAAgG;AAChG,gBAAgB,8DAA8D;EAC5E,yBAAyB,EAAE,2BAA2B;EACtD,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gDAAgD,EAAE,0BAA0B;EAC5E,8CAA8C;AAChD;;AAEA,uCAAuC;AACvC;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/* src/pages/style/login.css */\n\n/* Импортируем шрифт для футуристичного/минималистичного вида */\n/* Google Fonts: Inter - чистый, современный sans-serif */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap');\n\n/* Глобальные сбросы и базовые стили */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', sans-serif; /* Использование импортированного шрифта */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n \n.login-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Занимает всю высоту viewport */\n  background-color: #0a0a1a; /* Очень темный, почти черный фон с фиолетовым оттенком */\n  color: #e0e0e0; /* Светлый текст для контраста */\n}\n\n.login-header {\n  background-color: #1a0f2b; /* Темный пурпурный цвет для шапки */\n  color: #f0f0f0;\n  padding: 25px 0;\n  text-align: center;\n  box-shadow: 0 0 15px rgba(147, 112, 219, 0.4); /* Мягкое фиолетовое свечение */\n  border-bottom: 1px solid rgba(147, 112, 219, 0.2); /* Тонкая разделительная линия */\n}\n\n.login-header h1 {\n  margin: 0;\n  font-size: 2.8em;\n  font-weight: 700;\n  letter-spacing: 2px; /* Небольшой межбуквенный интервал */\n  text-shadow: 0 0 10px rgba(147, 112, 219, 0.7); /* Эффект свечения для текста */\n}\n\n.login-main-content {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.login-form-container {\n  background-color: rgba(20, 0, 40, 0.8); /* Полупрозрачный темно-пурпурный фон для эффекта \"стекла\" */\n  padding: 45px;\n  border-radius: 12px; /* Более мягкие углы */\n  box-shadow: 0 0 40px rgba(138, 43, 226, 0.4), /* Внешнее фиолетовое свечение */\n              inset 0 0 15px rgba(147, 112, 219, 0.2); /* Внутреннее свечение */\n  border: 1px solid rgba(147, 112, 219, 0.3); /* Тонкая фиолетовая рамка */\n  width: 100%;\n  max-width: 420px; /* Немного шире для лучшего вида */\n  text-align: center;\n  backdrop-filter: blur(5px); /* Эффект размытия фона (для современного \"стеклянного\" вида) */\n  -webkit-backdrop-filter: blur(5px); /* Для Safari */\n}\n\n.login-form-container h2 {\n  margin-top: 0;\n  margin-bottom: 35px;\n  color: #9370DB; /* Средний пурпурный для заголовка */\n  font-size: 2.2em;\n  font-weight: 700;\n  text-shadow: 0 0 8px rgba(147, 112, 219, 0.6);\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px; /* Больше отступов между элементами формы */\n}\n\n.form-group {\n  text-align: left;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 400;\n  color: #c0c0c0; /* Светло-серый для меток */\n  font-size: 0.95em;\n  letter-spacing: 0.5px;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"password\"] {\n  width: 100%;\n  padding: 14px 18px;\n  background-color: rgba(10, 0, 20, 0.6); /* Очень темный, полупрозрачный фон для полей */\n  border: 1px solid rgba(147, 112, 219, 0.4); /* Фиолетовая рамка */\n  border-radius: 8px; /* Слегка закругленные углы */\n  font-size: 1.05em;\n  color: #f0f0f0; /* Светлый текст внутри полей */\n  box-sizing: border-box;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-group input[type=\"text\"]::placeholder,\n.form-group input[type=\"password\"]::placeholder {\n  color: #888; /* Цвет плейсхолдера */\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"password\"]:focus {\n  border-color: #8A2BE2; /* Яркий фиолетовый при фокусе */\n  outline: none;\n  box-shadow: 0 0 15px rgba(138, 43, 226, 0.7), /* Яркое фиолетовое свечение при фокусе */\n              inset 0 0 8px rgba(138, 43, 226, 0.3);\n  background-color: rgba(10, 0, 20, 0.8); /* Чуть темнее при фокусе */\n}\n\n.login-button {\n  background: linear-gradient(45deg, #8A2BE2, #9370DB); /* Градиент от яркого фиолетового до пурпурного */\n  color: white;\n  padding: 16px 30px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.2em;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 25px;\n  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4); /* Мягкая тень для \"парящего\" эффекта */\n  letter-spacing: 1px;\n}\n\n.login-button:hover {\n  background: linear-gradient(45deg, #9370DB, #8A2BE2); /* Изменение направления градиента при наведении */\n  transform: translateY(-3px); /* Небольшой эффект поднятия */\n  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6); /* Более выраженная тень */\n}\n\n.login-button:active {\n  transform: translateY(0);\n  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.4);\n  background: #8A2BE2; /* Сплошной цвет при нажатии */\n}\n\n/* Стили для футера (если он не имеет своего отдельного CSS-файла и вы хотите его стилизовать здесь) */\n/* Если Footer имеет свой Footer.css, то эти стили могут быть переопределены или дополнены там */\nfooter.footer { /* Указываем класс, чтобы не конфликтовать с тегом <footer/> */\n  background-color: #120720; /* Очень темный пурпурный */\n  color: #b0b0b0;\n  text-align: center;\n  padding: 20px 0;\n  font-size: 0.85em;\n  width: 100%;\n  box-shadow: 0 -2px 10px rgba(147, 112, 219, 0.2); /* Мягкое свечение снизу */\n  border-top: 1px solid rgba(147, 112, 219, 0.1);\n}\n\n/* Адаптивность для маленьких экранов */\n@media (max-width: 600px) {\n  .login-form-container {\n    padding: 35px 25px;\n    margin: 0 15px;\n  }\n\n  .login-header h1 {\n    font-size: 2.2em;\n  }\n\n  .login-form-container h2 {\n    font-size: 1.9em;\n  }\n\n  .login-button {\n    padding: 14px 25px;\n    font-size: 1.1em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
